import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {ShippingCarrierTypeDto, ShippingClientDataDto} from "../../api/fms";
import {validationStore} from "../ValidationStore";
import {equals} from "../../utils";
import {FmsShippingFormData, FmsShippingFormValidation} from "./FmsShippingClientCommons";

const systemApi = api.fms.api

const emptyObject = {
    carrier: ShippingCarrierTypeDto.DHL,
    clientNumber: '',
    label: ''
}

class FmsShippingClientCreateStore {
    get valid(): boolean {
        return this._valid;
    }

    set valid(value: boolean) {
        this._valid = value;
    }
    get label(): string {
        return this._label;
    }

    set label(value: string) {
        this._label = value;
    }
    get clientNumber(): string {
        return this._clientNumber;
    }

    set clientNumber(value: string) {
        this._clientNumber = value;
    }
    get carrier(): ShippingCarrierTypeDto {
        return this._carrier;
    }

    set carrier(value: ShippingCarrierTypeDto) {
        this._carrier = value;
    }
    get creating(): boolean {
        return this._creating;
    }

    private set creating(value: boolean) {
        this._creating = value;
    }

    get formValidation(): FmsShippingFormValidation {
        return {
            carrier: validationStore.getFor('carrier'),
            clientNumber: validationStore.getFor('clientNumber'),
            label: validationStore.getFor('label'),
        }
    }

    get formData(): FmsShippingFormData {
        const {
            carrier,
            clientNumber,
            label
        } = this
        return {
            label,
            carrier,
            clientNumber
        }
    }

    set formData(value: FmsShippingFormData) {
        const {
            carrier,
            clientNumber,
            label
        } = value
        this.carrier = carrier
        this.clientNumber = clientNumber
        this.label = label
    }

    get dirty(): boolean {
        const current = this.buildDto()
        return !equals(emptyObject, current)
    }

    private _carrier: ShippingCarrierTypeDto = ShippingCarrierTypeDto.DHL
    private _clientNumber: string = ''
    private _label: string = ''

    private _valid: boolean = false
    private _creating: boolean = false

    constructor() {
        makeAutoObservable(this)
        this.reset()
    }

    reset() {
        this.carrier = emptyObject.carrier
        this.clientNumber = emptyObject.clientNumber
        this.label = emptyObject.label
    }

    async create(): Promise<any> {
        this.creating = true
        const dto = this.buildDto()
        const response = await catchApi(
            async () => await systemApi.createShippingClient(dto)
        )
        const result = response?.data
        this.creating = false
        return result?.id
    }

    async validate() {
        this.valid = false
        const dto = this.buildDto()
        if (!dto) {
            return
        }
        await validationStore.validate(systemApi.validateShippingClient, dto)
        this.valid = Boolean(validationStore.valid)
    }

    buildDto(): ShippingClientDataDto {
        const {
            carrier,
            clientNumber,
            label
        } = this
        return {
            label,
            carrier,
            clientNumber
        }
    }

}

const fmsShippingClientCreateStore = new FmsShippingClientCreateStore()

export {
    fmsShippingClientCreateStore
}
